import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    informer: 'relative z-1 h-[32px] w-full',

    container:
      'container flex h-full items-center justify-center md:justify-between',

    top: 'flex h-[48px] w-full gap-4 px-[14px] transition md:relative md:h-[58px]',
    topLogo: 'flex-center lg:-mb-5',
    logoNaos:
      'flex-center w-[125px] flex-1 border-r-1 pr-3 lg:w-[196px] lg:pr-5',
    logoBioderma:
      'flex-center ml-3 w-[62px] flex-1 hover:opacity-70 lg:ml-4 lg:w-[100px]',
    logoEsthederm:
      'flex-center ml-4 w-[55px] flex-1 hover:opacity-70 lg:ml-1 lg:w-[100px]',
    logoEtatPur:
      'flex-center ml-4 w-[65px] flex-1 hover:opacity-70 lg:ml-1 lg:w-[100px]',
    topLeftLink:
      'link hidden w-[200px] items-center justify-start whitespace-nowrap md:-mb-[10px] md:flex',
    topRightLink:
      'link hidden w-[200px] items-center justify-end whitespace-nowrap md:-mb-[10px] md:flex',
    link: 'truncate',
    main: 'hidden h-[48px] w-full items-center justify-between transition md:flex md:h-[64px]',
    mainLogo: 'mx-auto min-w-[152px] opacity-0 transition-opacity',
    linksLeft: 'flex h-full w-[500px] gap-5 lg:gap-10',
    linksRight: 'flex w-[500px] justify-end gap-5 lg:gap-[32px]',
    linkCatalog:
      'link-border border-blue-dark relative flex min-h-[40px] min-w-[40px] items-center font-semibold',
    linkItem:
      'link-border relative hidden min-h-[40px] min-w-[40px] items-center font-semibold lg:flex',
    linkIcon: 'link relative flex min-h-[40px] min-w-[40px] items-center',
    linkCounter: 'absolute top-0 left-5',
    linkLabel: 'hidden pl-2 font-semibold lg:block',
    linkArrow: '-mb-[2px] ml-2',

    backArrow: 'link ml-1 hidden size-6 rotate-180 md:size-[36px]',
    crossArrow: 'link ml-1 hidden size-6 md:size-[36px]',

    menuOverlay:
      'l-0 fixed top-[var(--head-fixed-height-0)] z-49 h-[calc(100vh-var(--head-fixed-height-0))] w-full overflow-auto bg-black/50 pb-[30px]',
    searchSuggestion: 'h-full w-full overflow-auto bg-white'
  },
  variants: {
    color: {
      base: {
        informer: 'bg-blue-dark text-white'
      },
      white: {
        informer: 'bg-blue-dark text-white',
        top: 'bg-white',
        main: 'bg-white'
      },
      transparent: {
        informer: 'bg-blue-light',
        top: 'bg-transparent text-white',
        main: 'bg-transparent text-white'
      },
      checkout: {
        informer: 'hidden',
        top: 'hidden',
        main: 'shadow-header flex rounded-b-xl bg-white md:rounded-none',
        mainLogo: 'opacity-100',
        linksLeft: 'hidden',
        linksRight: 'hidden',
        backArrow: 'flex',
        crossArrow: 'flex'
      }
    },
    fixed: {
      true: {
        main: 'shadow-header bg-white text-black',
        mainLogo: 'opacity-100',
        top: 'shadow-header bg-white text-black md:shadow-none'
      }
    },
    shadow: {
      true: {
        main: 'shadow-header'
      }
    }
  },
  defaultVariants: {
    color: 'base',
    fixed: false,
    shadow: false
  }
});
